import { getQueryString } from '../../../domain/url-provider';
import { ICompareBundlesData } from '../interfaces';
import { getHiddenDataString } from '../../../domain/hidden-data-provider';

const COMPARE_BUNDLES_STORAGE = 'compare-bundles';
export const MAX_ITEMS = 4;
export const COMPARE_BUNDLES_EVENT = 'compare-bundles-evt';

export const getHiddenData = () : ICompareBundlesData|null => {
    const strData = getHiddenDataString('compare-bundles-data');
    if(!strData) return null;

    try{
        const data = JSON.parse(strData) as ICompareBundlesData;
        return formatData(data);
    }
    catch (ex){
        return null;
    }
};

export const parseDocumentIDs = (): number[] => {
    const qs = getQueryString()['ids'];
    if(!qs) return [];

    const set: Set<number> = new Set();

    const parts = qs.split('-');
    for(const part of parts){
        const id = Number(part) || 0;
        if(id === 0) continue;
        set.add(id);
    }

    return Array.from(set);
};

export const formatData = (data: ICompareBundlesData) => {
    if(!data) return data;

    const map: Map<number, Set<number>> = new Map(); // bundle id --> set of plugin IDs
    for(const item of data?.connections){
        const set = map.get(item.bundleDocumentID) || new Set();
        set.add(item.pluginDocumentID);
        map.set(item.bundleDocumentID, set);
    }

    for(const plugin of data.plugins){
        plugin.included = [];

        let lastValue = undefined;
        let isAllSame = true;

        for(const bundle of data.bundles){
            const isIncluded = map.get(bundle.documentID)?.has(plugin.documentID) ?? false;
            plugin.included.push(isIncluded);

            if(lastValue !== undefined && lastValue !== isIncluded){
                isAllSame = false;
            }
            lastValue = isIncluded;
        }

        plugin.isAllIncludedTheSame = isAllSame;
    }

    return data;
};

export const getCompareBundlesFromStorage = (): number[] => {

    let data: number[] = [];

    try{
        data = JSON.parse(sessionStorage.getItem(COMPARE_BUNDLES_STORAGE) || '') || [];
    }
    catch(ex){}

    // remove duplicates ------------
    data = Array.from(new Set(data));

    return data;
};

export const isCompareBundlesDocumentIdChecked = (documentID: number): boolean => {
    const data = getCompareBundlesFromStorage();
    const index = data.findIndex(docId => docId === documentID);
    return index !== -1;
};

export const addDocToCompareBundles = (documentID: number): number[] => {
    let data = getCompareBundlesFromStorage();

    data.push(documentID);

    // remove duplicates -----------
    data = Array.from(new Set(data));

    let shouldSendEvent = false;
    if(data.length > MAX_ITEMS) {
        data.shift();
        shouldSendEvent = true;
    }

    sessionStorage.setItem(COMPARE_BUNDLES_STORAGE, JSON.stringify(data));

    if(shouldSendEvent){
        document.dispatchEvent(new CustomEvent(COMPARE_BUNDLES_EVENT));
    }

    return data;
};

export const removeDocFromCompareBundles = (documentID: number): number[] => {
    let data = getCompareBundlesFromStorage();
    const index = data.findIndex(doc => doc === documentID);
    if(index === -1) return data;

    data.splice(index, 1);

    sessionStorage.setItem(COMPARE_BUNDLES_STORAGE, JSON.stringify(data));

    return data;
};

/**
 * https://dev.waves.com/compare-bundles?ids=82-29-81-88
 */
export const getCompareBundlesUrl = () => {
    const data = getCompareBundlesFromStorage();
    if(data.length <= 0) return '/compare-bundles';
    return `/compare-bundles?ids=${ data.join('-') }`;
};